<div class="reading-page doc-page">
  <div id="head" class="section-header">
    <h2 class="section-title">AI Token Meter Privacy Policy</h2>
  </div>
  <app-policy-card [policyBody]="body">
    <!-- Body -->
    <ng-template #body>
      <div class="policy-content">
        <p><strong>Effective: 20 October 2026</strong></p>

        <p><strong>Who we are</strong></p>
        <p><a [routerLink]="URLS.plugins.macosAiTokenMeter">AI Token Meter</a> is made by <strong>Codigrate OÜ</strong>,
          registry code 16262630, Sepapaja tn 6, 15551 Tallinn, Estonia. You can reach us at
          <a [href]="'mailto:' + environmentCommon.company.email">{{ environmentCommon.company.email }}</a>.</p>

        <p><strong>No personal data</strong></p>
        <p>AI Token Meter collects no personal data. There is no account, no analytics, no advertising, no tracking and
          no third-party SDKs. Codigrate receives nothing about you or your work from it.</p>

        <p><strong>What the app reads on your Mac</strong></p>
        <p>Connecting Claude Code, Codex or Antigravity CLI is up to you. You choose each agent's folder yourself in
          macOS's open panel (.claude, .codex or .gemini/antigravity-cli in your home folder), and the app only reads
          it: from the logs the agent writes, it takes the token counts, the model, the time and the project folder of
          each request. Your prompts, the agents' answers and their tool calls are never read. The app writes nothing
          into these folders. Disconnect in Settings, Agents ends the access.</p>
        <p>What it reads is added up into a small summary kept in the app's own folder on your Mac, so later launches
          are quick. It never leaves your Mac.</p>

        <p><strong>The one network request</strong></p>
        <p>Once a day the app downloads the current list of AI model prices (LiteLLM's public price list) from
          codigrate.com, to show what your tokens would cost at API prices. The request carries nothing about you
          or your use. You can turn it off in Settings, Prices; the app then keeps the list it has.</p>

        <p><strong>Purchases</strong></p>
        <p>Bought on codigrate.com, the payment is handled by Stripe under its terms and privacy policy, and Codigrate
          keeps the order's e-mail address to deliver the download. Bought on the Mac App Store, Apple handles the
          payment under its terms and privacy policy. Codigrate never sees your card details.</p>

        <p><strong>Access, export and deletion</strong></p>
        <p>The app collects nothing, so there is nothing for Codigrate to access, export or delete from it. Deleting the
          app removes its summary. For an order on codigrate.com, write to us at
          <a [href]="'mailto:' + environmentCommon.company.email">{{ environmentCommon.company.email }}</a>.</p>

        <p><strong>Changes to this policy</strong></p>
        <p>If this policy changes, the new version will be posted on this page with a new effective date.</p>

        <p><strong>Terms of Use</strong></p>
        <p>On the Mac App Store, AI Token Meter's Terms of Use are Apple's standard
          <a [href]="eulaUrl" target="_blank" rel="noopener">Licensed Application End User License Agreement</a>.
          On codigrate.com, the <a [routerLink]="URLS.storeTerms">Terms of Sale</a> apply.</p>
      </div>
    </ng-template>
  </app-policy-card>
</div>
